import { render } from "./page-header.vue?vue&type=template&id=3dc7cbcf&scoped=true"
import script from "./page-header.vue?vue&type=script&lang=js"
export * from "./page-header.vue?vue&type=script&lang=js"

import "./page-header.vue?vue&type=style&index=0&id=3dc7cbcf&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dc7cbcf"]])

export default __exports__